import { createAsyncThunk } from "@reduxjs/toolkit";
import { HttpStatusCode } from "axios";
import { RootState } from "../../types";
import { axiosClient } from "../../../api/axios-client";
import { GetChatMessagesResponseDto } from "../../../types/dto/chat/get-chat-messages-response-dto";
import { setIsMessagesLoading } from "../chat-slice";
import { GetChatMessagesRequestDto } from "../../../types/dto/chat/get-chat-messages-request-dto";

export const getChatMessages = createAsyncThunk<
  // Return type of the payload creator
  GetChatMessagesResponseDto,
  // First argument to the payload creator
  void
  // Types for ThunkAPI,
>('chat-slice/fetch-local-storage-values',
  async (_, { getState, signal, rejectWithValue, fulfillWithValue, dispatch }) => {
    dispatch(setIsMessagesLoading(true));
    const state = getState() as RootState;

    const { suId, conversationId, merchId, sessionId } = state["app-state"];

    const reqDto: GetChatMessagesRequestDto = {
      su_id: suId,
      conversation_id: conversationId,
      merch_id: merchId,
      session_id: sessionId,
    }

    const response = await axiosClient.post<GetChatMessagesResponseDto>(
      '/getchat',
      reqDto,
      {
        signal
      }
    );
    dispatch(setIsMessagesLoading(false));
    if (response.status !== HttpStatusCode.Ok) {
      // Return the known error for future handling
      return rejectWithValue((response.data));
    }
    return fulfillWithValue(response.data);
  }
)
